export function generateInstructionSalt(): number {
  return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
}
